import {
  getSessionStorage,
  removeSessionStorage
} from '@cat-ecom/common/utils/storageUtils';
import {
  CatIconWarningCircle,
  CatInlineNotification
} from 'components/blocks-components';
import { Conditional } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { FC, useEffect, useState } from 'react';

interface FeedbackToastBannerProps {
  variant: 'success' | 'rejected';
}

export const FeedbackToastBanner: FC<FeedbackToastBannerProps> = ({
  variant
}) => {
  const t = useTranslations();
  const [showFeedbackToast, setShowFeedbackToast] = useState(() => false);

  useEffect(() => {
    const displayFeedbackToast = getSessionStorage('dismiss-all-feedback');

    if (displayFeedbackToast) {
      setShowFeedbackToast(true);
    } else {
      removeSessionStorage('dismiss-all-feedback');
    }
  }, [setShowFeedbackToast]);

  const variantIsRejected = variant === 'rejected';
  const parsedVariant = variantIsRejected ? 'error' : variant;
  const heading = variantIsRejected
    ? t('NOTIFICATIONS_ERROR')
    : t('DISMISS_NOTIFICATIONS_TOAST');

  return (
    <Conditional test={showFeedbackToast}>
      <div className="p-3 pb-2">
        <CatInlineNotification
          variant={parsedVariant ?? 'success'}
          heading={heading}
          dismissible
          onBlInlineNotificationClose={() => setShowFeedbackToast(false)}
        >
          <CatIconWarningCircle slot="before" />
        </CatInlineNotification>
      </div>
    </Conditional>
  );
};
